import { useState } from "react";
import { useLocation } from "react-router";
import { capturePageview } from "./posthog";

/**
 * Fires `$pageview` per route change (PostHog's capture_pageview only fires once).
 * Uses "set state during render" to dedupe without useEffect — same pattern as
 * `email-assistant/outlook-addin/src/main.tsx`.
 */
export function usePostHogPageviews(): null {
	const location = useLocation();
	const currentPath = `${location.pathname}${location.search}`;
	const [lastPath, setLastPath] = useState<string | null>(null);
	if (currentPath !== lastPath) {
		setLastPath(currentPath);
		capturePageview(currentPath);
	}
	return null;
}
